import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import {
  AccountService,
  ApplicationService,
  CookieService,
  DeveloperService,
  EntityService,
  GenericOldService,
  GenericService,
  GlobalAlertService,
  LoaderService,
  LocaleService,
  LoginService,
  LogoutService,
  PasswordService,
  PermissionService,
  ResourceService,
  RouterService,
  SessionService,
  TimezoneService,
  UserService,
} from '@service';
import { AuthHttpInterceptor, ErrorInterceptor, MockHttpInterceptor } from './interceptor';
import { CoreRoutingModule } from './routing';

const initRouterCheck = (routerService: RouterService) => (): Promise<void> => routerService.initRouterCheck();

@NgModule({
  exports: [CoreRoutingModule],
  imports: [CoreRoutingModule],
  providers: [
    AccountService,
    ApplicationService,
    CookieService,
    EntityService,
    DeveloperService,
    GlobalAlertService,
    LoaderService,
    LocaleService,
    LoginService,
    LogoutService,
    GenericService,
    GenericOldService,
    ResourceService,
    RouterService,
    PasswordService,
    PermissionService,
    SessionService,
    TimezoneService,
    UserService,
    {
      deps: [RouterService],
      multi: true,
      provide: APP_INITIALIZER,
      useFactory: initRouterCheck,
    },
    { multi: true, provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor },
    { multi: true, provide: HTTP_INTERCEPTORS, useClass: MockHttpInterceptor },
    { multi: true, provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  // Make sure CoreModule is imported only by one NgModule the LoginModule
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in LoginModule');
    }
  }
}
